import { render, staticRenderFns } from "./AttributeDisplay.vue?vue&type=template&id=3e2aea15"
import script from "./AttributeDisplay.vue?vue&type=script&lang=ts"
export * from "./AttributeDisplay.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports